const postEvent = async (
  id: string,
  type: string,
  details: unknown,
  channel?: string,
  direction?: string
): Promise<string> => {
  const url = `${import.meta.env.VITE_CATO_API_URL || ''}/contacts/${id}/events/${type}`;
  const currentDateTime = new Date().toISOString();
  const body = JSON.stringify({
    dateTime: currentDateTime,
    details: details,
    ...(channel && { channel }),
    ...(direction && { direction })
  });

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body
    });

    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }

    return await response.text();
  } catch (error) {
    throw error;
  }
};

export default postEvent;
